import { FormCard } from '../../../../../features/FormCard';
import { AppBox } from '../../../../../../../../../ui/boxes/AppBox';
import { AppText } from '../../../../../../../../../ui/text/AppText';
import { useLocalization } from '../../../../../../../../../lib/hooks/useLocalization';
import { SurveyTypeFormItem } from '../../../../../features/form-items/SurveyTypeFormItem';

export function SurveyType({ form }) {
  const { general } = useLocalization().translations.unique.pages.settings;

  return (
    <FormCard>
      <AppBox className='space_between' style={{ marginBottom: 24 }}>
        <AppText className='bold' textValue={general.surveyType} />
      </AppBox>
      <SurveyTypeFormItem form={form} />
    </FormCard>
  );
}
